/* eslint-disable import/no-cycle,consistent-return,default-case */
import React from 'react';
import { ThemeProvider, withTheme } from 'styled-components';
import cuid from 'cuid';
import filterTimeControl from '../../utils/filterTimeControl';
import Collapse from '../CustomCollapse';
import Wrapper from './Wrapper';
import { accordionTheme } from './theme';
import ComponentRecognizer from '../ComponentRecognizer';
var CustomAccordion = function (_a) {
    var _b, _c;
    var children = _a.children, contentData = _a.contentData, styleType = _a.styleType, styleMargin = _a.styleMargin, _d = _a.componentKey, componentKey = _d === void 0 ? cuid() : _d;
    var elements = [];
    if (!children) {
        (_c = (_b = contentData === null || contentData === void 0 ? void 0 : contentData.paragraph) === null || _b === void 0 ? void 0 : _b.filter(function (item) { return filterTimeControl(item); })) === null || _c === void 0 ? void 0 : _c.forEach(function (item) {
            var itemId = item.id, headline = item.field_headline, _a = item.field_is_open, isOpen = _a === void 0 ? false : _a;
            var content = item.field_html_editor ? (React.createElement("span", { key: "accordion-content-html-" + componentKey, 
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: { __html: item.field_html_editor } })) : (React.createElement(ComponentRecognizer, { content: item.paragraph, key: cuid() }));
            elements.push(content && (React.createElement(Collapse, { key: "accordion-collapse-" + itemId, headline: headline, id: itemId, isOpen: isOpen }, content)));
        });
    }
    return (React.createElement(ThemeProvider, { theme: accordionTheme },
        React.createElement(Wrapper, { styleType: styleType, styleMargin: styleMargin, key: "accordion-wrapper-" + componentKey },
            React.createElement("div", { className: "accordion-row", key: "accordion-row-" + componentKey },
                React.createElement("div", { className: "accordion-col", key: "accordion-col-" + componentKey },
                    React.createElement("div", { className: "accordion-tabs", key: "accordion-tabs-" + componentKey }, children || elements))))));
};
export default withTheme(CustomAccordion);
//# sourceMappingURL=index.js.map